function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M10 12C10 8.682 12.682 6 16 6C19.318 6 22 8.682 22 12C22 15.318 19.318 18 16 18C12.682 18 10 15.318 10 12ZM12 12C12 14.205 13.795 16 16 16C18.205 16 20 14.205 20 12C20 9.795 18.205 8 16 8C13.795 8 12 9.795 12 12Z",
  fill: "#54606A"
});
var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M8 8C10.2091 8 12 6.20914 12 4C12 1.79086 10.2091 0 8 0C5.79086 0 4 1.79086 4 4C4 6.20914 5.79086 8 8 8Z",
  fill: "#54606A"
});
var _ref4 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M8.24376 10.0292C8.08456 10.6594 8 11.3197 8 12C8 13.458 8.38839 14.8239 9.06754 16H0V14C0 11.5667 5.297 10.238 8.24376 10.0292Z",
  fill: "#54606A"
});
var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M16 10.59L18.59 8L20 9.41L17.41 12L16 13.41L13.41 16L12 14.59L14.59 12L16 10.59Z",
  fill: "#54606A"
});
function SvgNoshow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 18,
    viewBox: "0 0 22 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoshow);
export default __webpack_public_path__ + "static/media/noshow.50da346b.svg";
export { ForwardRef as ReactComponent };